import React, { useState, useEffect } from 'react';
import ConfirmButton from '../../../Components/Buttons/ConfirmButton';
import CancelButton from '../../../Components/Buttons/CancelButton';
import { getTags, getTagCategories } from '../utils';
import Modal from '../../../Components/Modal/Modal';
import ButtonContainer from '../../../Components/CheckableButton/ButtonContainer';
import CheckableButton from '../../../Components/CheckableButton/CheckableButton';
import FilterAccordion from '../../../Components/SearchTeacherFilter/CollapseFilter2';
import EcecCustomerFilterAccordion from '../../../Components/SearchTeacherFilter/EcecCustomerCollapseFilter';
// import './CanDeliver.css'
// import uuid from "uuid/v4";

// import './model_style.css'

// import { createUserObject } from '../../Profile/profile.utils'

function TagsForm(props) {
  // console.log(props.user)
  // let userObject = createUserObject(props.user, true, true)
  const [selected_tags, set_selected_tags] = useState(props.tags);
  const [show_vet, set_show_vet] = useState(false);
  const [show_elt, set_show_elt] = useState(true);
  const [show_tech, set_show_tech] = useState(false);
  const [is_checked, set_is_checked] = useState('elt');
  const tags_list = getTags();
  const category_options = getTagCategories();
  const [selectedTags, setSelectedTags] = useState(props.selectedList)
  const [selectedByQualification, setSelectedByQualification] = useState(props.selectedByQualificationObj)

  // console.log(userObject)
  // console.log(selected_tags)

  useEffect(() => {
    set_selected_tags(props.tags);
  }, [props.tags]);

  const setCategory = (e) => {
    set_is_checked(e.target.id);
  };

  const selectTag = (e) => {
    const tag_id = e.target.title;
    let newSelectedClasses = { ...selected_tags };

    if (e.target.checked) {
      if (!newSelectedClasses[is_checked].includes(tag_id)) {
        newSelectedClasses[is_checked].push(tag_id);
      }
    } else {
      newSelectedClasses[is_checked] = newSelectedClasses[is_checked].filter(
        (cl) => cl !== tag_id
      );
    }
    set_selected_tags(newSelectedClasses);
  };

  const handleTagChange = (e, qua, rootID = null) => {
    let currentList = selectedTags
    let selectedByQualificationNew = {
      ...selectedByQualification
    }
    if (e.target.checked) {
      currentList.push(e.target.value)
      if(e.target.value !== rootID) {
        currentList = currentList.filter(lv => lv !== rootID);
        if(qua?._id) {
          if(selectedByQualificationNew[qua._id]) {
            selectedByQualificationNew[qua._id] = [
              ...selectedByQualificationNew[qua._id],
              e.target.value
            ]?.filter(ele => ele !== rootID)
          }
          else {
            selectedByQualificationNew[qua._id] = [e.target.value]
          }
        }
      }
      else {
        if(qua?._id) {
          if(selectedByQualificationNew?.[qua._id]) {
            currentList = currentList.filter(lv => !selectedByQualificationNew?.[qua._id]?.includes(lv))
          }
          selectedByQualificationNew[qua._id] = [e.target.value]
        }
      }
      setSelectedTags(currentList)
    } else {
      // const splitValue = e.target.value.split("_id:")?.[0]
      currentList = currentList.filter(lv => lv !== e.target.value);
      if(qua?._id && selectedByQualificationNew?.[qua._id]) {
        selectedByQualificationNew[qua._id] = selectedByQualificationNew[qua._id].filter(lv => lv !== e.target.value)
      }
      setSelectedTags(currentList) 
    }
    setSelectedByQualification(selectedByQualificationNew)
  }

  return (
    <>
      <Modal
        show={props.show}
        onClose={props.onClose}
        className='model-for-addform custom-for-addCanDeliver'
        header={'Add/Remove Some ' + (props.type || 'Can Deliver')}
      >
        <div className='main-content-select'>
          {
            props.isChildcareCentre ? (
              <EcecCustomerFilterAccordion
                qualificationList={props.qualifications}
                selectedList={selectedTags}
                onChangeCategory={(e, qua, rootID) => handleTagChange(e, qua, rootID)}
                levels={props.levels}
                showTwoColumns
                isChildcareCentre={true}
              />
            ) : (
              <FilterAccordion 
                selectedList={selectedTags}
                qualificationList={props.qualifications}
                onChangeCategory={(e, qua, rootID) => handleTagChange(e, qua, rootID)}
                levels={props.levels}
                showTwoColumns
              />
            )
          }
          
        </div>
        <div className='row qualification-footer mt-5'>
          <div className='col-md-6 buttons'>
            <CancelButton onClick={props.onClose}>Cancel</CancelButton>
          </div>
          <div className='col-md-6 buttons'>
            <ConfirmButton
              onClick={() => {
                props.onSubmit(selectedTags);
              }}
            >
              Submit
            </ConfirmButton>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default TagsForm;
